import { useEffect } from 'react';
import { Link, Outlet, useParams } from 'react-router';
import { api } from '../api/client';
import { errorMessageKey } from '../api/api-error';
import { Notice } from '../components/ui/notice';
import { Spinner } from '../components/ui/spinner';
import { useI18n } from '../i18n/i18n';
import { CurrentWorkspaceContext } from '../workspaces/current-workspace';
import { useWorkspace } from '../workspaces/workspaces-api';
import { paths } from './paths';

/**
 * `/w/:workspaceId/…`: пространство с моими правами для вложенных экранов
 * (`useCurrentWorkspace`) и отметка «последнее открытое» для следующего входа (ADR-0014).
 */
export function WorkspaceRoute() {
  const { t } = useI18n();
  const { workspaceId = '' } = useParams();
  const workspace = useWorkspace(workspaceId);
  const openedId = workspace.data?.id;

  useEffect(() => {
    if (openedId === undefined) return;
    // Подсказка для следующего входа; ошибка здесь пользователю не важна.
    void api.POST('/api/v1/workspaces/{workspaceId}/open', {
      params: { path: { workspaceId: openedId } },
    });
  }, [openedId]);

  if (workspace.isPending) {
    return (
      <div className="grid min-h-dvh place-items-center">
        <Spinner label={t('common.loading')} />
      </div>
    );
  }
  if (workspace.isError || workspace.data === null) {
    return (
      <div className="mx-auto max-w-sm space-y-3 px-6 pt-24">
        <Notice tone="danger">
          {workspace.isError ? t(errorMessageKey(workspace.error)) : t('error.WORKSPACE_NOT_FOUND')}
        </Notice>
        <Link to={paths.workspaces} className="text-sm text-primary hover:underline">
          {t('workspaces.toList')}
        </Link>
      </div>
    );
  }
  return (
    <CurrentWorkspaceContext.Provider value={workspace.data}>
      <Outlet />
    </CurrentWorkspaceContext.Provider>
  );
}
